import React from "react";
import { Link } from "react-router-dom";
import LegalLayout from "@/components/legal/LegalLayout";
import { SITE, LEGAL } from "@/lib/config";
import SEO from "@/components/seo/SEO";

export default function PoliticaPrivacidad() {
    return (
        <>
            <SEO
                title="Política de Privacidad"
                description="Política de privacidad de ASATTA conforme al RGPD y a la LOPDGDD. Información sobre el tratamiento de datos personales."
                path="/politica-de-privacidad"
            />
            <LegalLayout
            testId="politica-privacidad-page"
            eyebrow="Protección de datos"
            title="Política de Privacidad"
            updatedAt={LEGAL.updatedAt}
        >
            <p>
                En ASATTA nos comprometemos a proteger los datos personales de las
                personas que se ponen en contacto con nosotros o solicitan el alta como
                asociados. La presente Política de Privacidad se ajusta al Reglamento
                (UE) 2016/679 (RGPD), a la Ley Orgánica 3/2018, de 5 de diciembre, de
                Protección de Datos Personales y garantía de los derechos digitales
                (LOPDGDD) y a la Ley 34/2002 (LSSI-CE).
            </p>

            <h2>1. Responsable del tratamiento</h2>
            <ul>
                <li><strong>Titular:</strong> {SITE.fullName} (ASATTA)</li>
                <li><strong>CIF:</strong> {LEGAL.cif}</li>
                <li><strong>Domicilio:</strong> {SITE.address}</li>
                <li><strong>Correo electrónico:</strong> <a href={`mailto:${SITE.email}`}>{SITE.email}</a></li>
            </ul>
            <p>
                ASATTA es una asociación sin ánimo de lucro y actúa como responsable del
                tratamiento de los datos personales que le facilitan los usuarios y
                asociados.
            </p>

            <h2>2. Finalidad del tratamiento</h2>
            <p>Los datos personales que nos facilite serán tratados con las siguientes finalidades:</p>
            <ul>
                <li>Atender consultas, peticiones y comunicaciones remitidas a través del formulario de contacto o por correo electrónico.</li>
                <li>Gestionar las solicitudes de alta como asociado y, en su caso, la posterior relación asociativa (comunicaciones, gestión de cuotas, información sectorial, actividades y proyectos).</li>
                <li>Publicar, cuando así se autorice, la ficha del alojamiento en el directorio público de asociados.</li>
                <li>Enviar información sobre las actividades, noticias, eventos e iniciativas de la asociación cuando exista una base jurídica que lo permita.</li>
                <li>Cumplir con las obligaciones legales y contables aplicables a la asociación.</li>
            </ul>

            <h2>3. Base jurídica</h2>
            <ul>
                <li><strong>Formulario de contacto:</strong> el consentimiento del interesado, otorgado al remitir el formulario (art. 6.1.a RGPD).</li>
                <li><strong>Solicitud de alta como asociado:</strong> la adopción de medidas precontractuales a petición del interesado y, en caso de admisión, la ejecución de la relación asociativa (art. 6.1.b RGPD), así como el interés legítimo de la asociación en la gestión de sus asociados (art. 6.1.f RGPD).</li>
                <li><strong>Envío de comunicaciones informativas a asociados:</strong> el interés legítimo de la asociación en informar a sus asociados sobre asuntos del sector y actividades propias (art. 6.1.f RGPD).</li>
                <li><strong>Cookies analíticas y de personalización:</strong> el consentimiento del usuario (art. 6.1.a RGPD y art. 22 LSSI-CE).</li>
                <li><strong>Obligaciones legales:</strong> el cumplimiento de obligaciones legales aplicables a ASATTA (art. 6.1.c RGPD).</li>
            </ul>

            <h2>4. Categorías de datos tratados</h2>
            <p>
                Únicamente tratamos los datos que el usuario nos facilita voluntariamente
                a través de los formularios del sitio web o por correo electrónico. Con
                carácter general, se recogen las siguientes categorías:
            </p>
            <ul>
                <li>Datos identificativos: nombre y apellidos.</li>
                <li>Datos de contacto: dirección de correo electrónico y, en su caso, teléfono.</li>
                <li>Datos profesionales: empresa o alojamiento representado y cargo o relación con el mismo.</li>
                <li>Contenido del mensaje o solicitud remitida.</li>
                <li>Datos de navegación derivados del uso de cookies, en los términos de la Política de Cookies.</li>
            </ul>
            <p>
                No se tratan categorías especiales de datos personales (datos de salud,
                ideología, religión, etc.).
            </p>

            <h2>5. Conservación de los datos</h2>
            <ul>
                <li>Los datos de consultas de contacto se conservarán durante el tiempo necesario para atender la consulta y, con posterioridad, durante los plazos legalmente exigibles para la determinación de posibles responsabilidades.</li>
                <li>Los datos de asociados se conservarán mientras se mantenga la relación asociativa y, tras su finalización, durante los plazos de prescripción de las obligaciones legales aplicables.</li>
                <li>Los datos tratados sobre la base del consentimiento se conservarán hasta que el interesado retire dicho consentimiento.</li>
            </ul>

            <h2>6. Destinatarios y encargados del tratamiento</h2>
            <p>
                Con carácter general, ASATTA no cede datos personales a terceros salvo
                obligación legal. No obstante, para la prestación de determinados
                servicios ASATTA puede contar con proveedores que actúan como encargados
                del tratamiento en su nombre y por su cuenta, en particular:
            </p>
            <ul>
                <li>Proveedores de alojamiento y mantenimiento del sitio web y de las herramientas de gestión de la asociación.</li>
                <li>Proveedores de servicios de correo electrónico y comunicación.</li>
                <li>Asesores externos (gestoría, asesoría fiscal y contable) cuando resulte necesario.</li>
            </ul>
            <p>
                Todos los encargados del tratamiento están contractualmente obligados a
                cumplir la normativa de protección de datos y a tratar los datos
                únicamente conforme a las instrucciones de ASATTA.
            </p>

            <h2>7. Transferencias internacionales de datos</h2>
            <p>
                ASATTA no realiza transferencias internacionales de datos fuera del
                Espacio Económico Europeo. En caso de que en el futuro se recurra a
                proveedores que impliquen transferencias internacionales, éstas se
                efectuarán exclusivamente con las garantías previstas por la normativa
                europea (decisión de adecuación, cláusulas contractuales tipo u otras
                garantías apropiadas) y esta política se actualizará en consecuencia.
            </p>

            <h2>8. Derechos de los usuarios</h2>
            <p>
                Las personas interesadas pueden ejercer, en cualquier momento y de forma
                gratuita, los siguientes derechos:
            </p>
            <ul>
                <li><strong>Acceso:</strong> conocer qué datos personales estamos tratando.</li>
                <li><strong>Rectificación:</strong> solicitar la corrección de datos inexactos o incompletos.</li>
                <li><strong>Supresión:</strong> pedir la eliminación de los datos cuando ya no sean necesarios.</li>
                <li><strong>Oposición:</strong> oponerse al tratamiento de sus datos por motivos relacionados con su situación particular.</li>
                <li><strong>Limitación:</strong> solicitar la restricción del tratamiento en los supuestos legalmente previstos.</li>
                <li><strong>Portabilidad:</strong> recibir los datos en un formato estructurado y de uso común, o solicitar su transmisión a otro responsable.</li>
                <li><strong>Retirada del consentimiento:</strong> retirar en cualquier momento el consentimiento prestado, sin que ello afecte a la licitud del tratamiento previo.</li>
            </ul>
            <p>
                Estos derechos pueden ejercerse mediante escrito dirigido a{" "}
                <a href={`mailto:${SITE.email}`}>{SITE.email}</a> o por correo postal a
                la dirección indicada al inicio de este documento, acompañando copia del
                documento de identidad o documento equivalente que permita acreditar la
                identidad del solicitante.
            </p>

            <h2>9. Reclamación ante la autoridad de control</h2>
            <p>
                La persona interesada tiene derecho a presentar una reclamación ante la
                Agencia Española de Protección de Datos (AEPD) cuando considere que el
                tratamiento de sus datos personales no se ajusta a la normativa vigente.
                Puede hacerlo a través de su sede electrónica en{" "}
                <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" className="underline">
                    www.aepd.es
                </a>
                {" "}o en su dirección postal: C/ Jorge Juan, 6, 28001 Madrid.
            </p>

            <h2>10. Medidas de seguridad</h2>
            <p>
                ASATTA ha adoptado las medidas técnicas y organizativas apropiadas para
                garantizar un nivel de seguridad adecuado al riesgo del tratamiento,
                conforme al artículo 32 del RGPD. Estas medidas incluyen, entre otras,
                el cifrado en tránsito, el control de accesos, la formación del personal
                autorizado y la revisión periódica de los proveedores.
            </p>

            <h2>11. Modificaciones</h2>
            <p>
                ASATTA se reserva el derecho a modificar la presente Política de
                Privacidad para adaptarla a novedades legislativas o cambios en su
                actividad. Cualquier modificación será publicada en esta misma página con
                indicación de la fecha de actualización.
            </p>

            <p className="mt-10 text-sm text-[#718096]">
                Consulta también nuestra{" "}
                <Link to="/politica-de-cookies" className="underline">
                    Política de Cookies
                </Link>{" "}y nuestro{" "}
                <Link to="/aviso-legal" className="underline">
                    Aviso Legal
                </Link>
                .
            </p>
        </LegalLayout>
        </>
    );
}
